import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Details } from './components';
import useEnrichedSchema from './useEnrichedSchema';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const EnrichedSchemaDetails = () => {
  const schema = useEnrichedSchema();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Details
          schema={schema}
          showNav={true}
          next="/enriched-schema/design"
        />
      </div>
    </div>
  );
};

export default EnrichedSchemaDetails;
